<!-- BEGIN: Subheader -->
<div class="m-subheader ">
    <div class="d-flex align-items-center">
        <div class="mr-auto">
            <h3 class="m-subheader__title m-subheader__title--separator">Nuevo subtipo producto</h3>
            <ul class="m-subheader__breadcrumbs m-nav m-nav--inline">
                <li class="m-nav__item m-nav__item--home">
                    <a [routerLink]="''" class="m-nav__link m-nav__link--icon">
                        <i class="m-nav__link-icon la la-home"></i>
                    </a>
                </li>
                <li class="m-nav__separator">-</li>
                <li class="m-nav__item">
                    <a [routerLink]="'/brand-sub-type-products'" class="m-nav__link">
                        <span class="m-nav__link-text">Subtipo productos</span>
                    </a>
                </li>
                <li class="m-nav__separator">-</li>
                <li class="m-nav__item">
                    <a *ngIf="sub_type_product.id == null" [routerLink]="'/brand-sub-type-products/create'" class="m-nav__link">
                        <span class="m-nav__link-text">Crear tipo producto</span>
                    </a>
                    <a *ngIf="sub_type_product.id != null" [routerLink]="['/brand-sub-type-products/edit', sub_type_product.id]" class="m-nav__link">
                        <span class="m-nav__link-text">Editar tipo producto</span>
                    </a>
                </li>
            </ul>
        </div>
    </div>
</div>

<div class="m-content">
    <div class="row">
        <div class="col-md-12">
            <!--begin::Portlet-->
            <div class="m-portlet m-portlet--mobile">
                <div class="m-portlet__head">
                    <div class="m-portlet__head-caption">
                        <div class="m-portlet__head-title">
                            <h3 *ngIf="sub_type_product.id == null" class="m-portlet__head-text">
                                Crear subtipo producto
                            </h3>
                            <h3 *ngIf="sub_type_product.id != null" class="m-portlet__head-text">
                                Editar subtipo producto - {{sub_type_product.name}}
                            </h3>
                        </div>
                    </div>
                    <div class="m-portlet__head-tools">
                        <ul class="m-portlet__nav">
                            <li class="m-portlet__nav-item">
                                <a [routerLink]="'/brand-sub-type-products'"
                                   class="m-portlet__nav-link btn btn-lg btn-secondary m-btn m-btn--outline-2x m-btn--air m-btn--icon m-btn--icon-only m-btn--pill  m-dropdown__toggle">
                                    <i class="flaticon-reply"></i>
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
                <form [formGroup]="form" (ngSubmit)="sendForm()" class="m-form m-form--label-align-right">
                    <div class="m-portlet__body">
                        <div class="m-form__section m-form__section--first">
                            <div class="form-group m-form__group row">
                                <label class="col-lg-2 col-form-label">Nombre:</label>
                                <div class="col-lg-6">
                                    <input formControlName="name" class="form-control m-input" placeholder="Nombre"
                                           [ngClass]="{ 'is-invalid': submitted && f.name.errors }">
                                    <div *ngIf="submitted && f.name.errors" class="invalid-feedback">
                                        <div *ngIf="f.name.errors.required">Nombre obligatorio</div>
                                    </div>
                                </div>
                            </div>
                            <div class="form-group m-form__group row">
                                <label class="col-lg-2 col-form-label">Tipo producto:</label>
                                <div class="col-lg-4">
                                    <select class="form-control m-input" formControlName="type_product_id" (change)="onSelectTypeProduct($event)">
                                        <option [value]='null' selected>Seleccione una tipo producto</option>
                                        <option [value]="item.id" *ngFor="let item of type_products">{{ item.name }}</option>
                                    </select>
                                </div>
                                <div class="col-lg-2">
                                    <button type="button" (click)="addTypeProduct()"
                                            class="btn btn-primary" style="height: 100%;width: 100%;padding: 0;">
                                        + Agregar marca
                                    </button>
                                </div>
                            </div>
                            <div *ngIf="type_product_data.length > 0" class="form-group m-form__group row">
                                <div class="col-lg-2"></div>
                                <div class="col-lg-6">
                                    <div class="info_data" *ngFor="let item of type_product_data">
                                        <div class="content_data">
                                            <svg (click)="deleteTypeProduct(item.id)" xmlns="http://www.w3.org/2000/svg"
                                                 width="16" height="16" fill="currentColor" class="bi bi-x delete_data"
                                                 viewBox="0 0 16 16">
                                                <path
                                                    d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
                                            </svg>
                                            <p>{{ item.name }}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="m-portlet__foot m-portlet__foot--fit">
                        <div class="m-form__actions">
                            <div class="row">
                                <div class="col-2">
                                </div>
                                <div class="col-7">
                                    <button type="submit" [disabled]="loading"
                                            class="btn btn-accent m-btn m-btn--air m-btn--custom"
                                            [ngClass]="{'m-loader m-loader--light m-loader--right': loading}">
                                        Guardar Cambios
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>
